import { CompanyList } from '../cmps/util-cmps/database'

export type CompanySearchMatch = {
    company: CompanyList
    matchedEntityName?: string
    isEntityMatch: boolean
}

const normalize = (value: string) => value.trim().toLowerCase()

const entityMatches = (entityName: string, searchTerm: string) => {
    const normalizedEntity = normalize(entityName)
    return normalizedEntity.startsWith(searchTerm) || normalizedEntity.includes(searchTerm)
}

export const getCompanySearchMatch = (company: CompanyList, filterText: string): CompanySearchMatch | null => {
    const searchTerm = normalize(filterText)

    if (!searchTerm) {
        return { company, isEntityMatch: false }
    }

    if (normalize(company.name).includes(searchTerm)) {
        return { company, isEntityMatch: false }
    }

    const matchedEntity = company.entity?.find(entity => entityMatches(entity.name, searchTerm))
    if (matchedEntity) {
        return {
            company,
            matchedEntityName: matchedEntity.name,
            isEntityMatch: true,
        }
    }

    return null
}

export const getCompanySearchMatches = (companies: CompanyList[], filterText: string) => {
    const matches = (companies ?? [])
        .map(company => getCompanySearchMatch(company, filterText))
        .filter((match): match is CompanySearchMatch => !!match)

    if (!normalize(filterText)) {
        return matches
    }

    return matches.sort((a, b) => Number(b.isEntityMatch) - Number(a.isEntityMatch) || a.company.name.localeCompare(b.company.name))
}
